export default __webpack_public_path__ + "static/media/java.841432fe.svg";